import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { IAppState } from '@myStore/app.state';
import {
  EEventsViewActions,
  GetEventFailure,
  GetEventRequest,
  GetEventsByPeriodFailure,
  GetEventsByPeriodRequest,
  GetEventsByPeriodSuccess,
  GetEventsFailure,
  GetEventsRequest,
  GetEventsSuccess,
  GetEventSuccess,
  GetVideoLinkFailure,
  GetVideoLinkRequest,
  GetVideoLinkSuccess,
} from '@myStore/events-view/events-view.actions';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { EventsViewService } from '@services/events-view/events-view.service';
import { ToastrService } from 'ngx-toastr';
import { catchError, map, switchMap } from 'rxjs/operators';
import { UserInfoLoadingForTabs } from '@myStore/users/user.actions';

@Injectable()
export class EventsViewEffects {
  constructor(
    private _actions$: Actions,
    private _store: Store<IAppState>,
    private _eventsViewService: EventsViewService,
    private _router: Router,
    private _toastr: ToastrService
  ) {}

  $get = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<GetEventsRequest>(EEventsViewActions.GetEventsRequest),
        switchMap(action => {
          return this._eventsViewService.get(action.qParams).pipe(
            map(events => {
              this._store.dispatch(new GetEventsSuccess(events));
              this._store.dispatch(new UserInfoLoadingForTabs(false));
            }),
            catchError(err => {
              this._toastr.error(
                `${
                  err?.error?.detail
                    ? err?.error?.detail
                    : 'При получении события возникла ошибка'
                }`,
                'Что-то пошло не так',
                {
                  timeOut: 3500,
                }
              );
              this._store.dispatch(new GetEventsFailure(err.error));
              this._store.dispatch(new UserInfoLoadingForTabs(false));
              return err.error;
            })
          );
        })
      );
    },
    { dispatch: false }
  );

  $getById = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<GetEventRequest>(EEventsViewActions.GetEventRequest),
        switchMap(action => {
          return this._eventsViewService.getById(action.payload).pipe(
            map(event => {
              this._store.dispatch(new GetEventSuccess(event));
            }),
            catchError(e => {
              this._toastr.error(
                `${
                  e?.error?.detail
                    ? e?.error?.detail
                    : 'При получении события по id возникла ошибка'
                }`,
                'Не удалось получить событие.',
                { timeOut: 3500 }
              );
              this._store.dispatch(new GetEventFailure(e));
              return e;
            })
          );
        })
      );
    },
    { dispatch: false }
  );

  $getByPeriod = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<GetEventsByPeriodRequest>(
          EEventsViewActions.GetEventsByPeriodRequest
        ),
        switchMap(action => {
          return this._eventsViewService.getByPeriod(action.periodId).pipe(
            map(events => {
              this._store.dispatch(new GetEventsByPeriodSuccess(events));
            }),
            catchError(err => {
              this._toastr.error(
                `${
                  err?.error?.detail
                    ? err?.error?.detail
                    : 'При получении периода возникла ошибка'
                }`,
                'Что-то пошло не так',
                {
                  timeOut: 3500,
                }
              );
              this._store.dispatch(new GetEventsByPeriodFailure(err.error));
              return err.error;
            })
          );
        })
      );
    },
    { dispatch: false }
  );

  $getVideoLink = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<GetVideoLinkRequest>(EEventsViewActions.GetVideoLinkRequest),
        switchMap(action => {
          return this._eventsViewService.getVideoLink(action.eventId).pipe(
            map(() => {
              this._store.dispatch(new GetVideoLinkSuccess());
              this._toastr.success(
                `Загрузка видео для ивента ${action.eventId} запущена`
              );
            }),
            catchError(err => {
              this._toastr.error(
                `${
                  err?.error?.detail
                    ? err?.error?.detail
                    : 'При загрузке видео возникла ошибка'
                }`,
                'Что-то пошло не так',
                {
                  timeOut: 3500,
                }
              );
              this._store.dispatch(new GetVideoLinkFailure());
              return err.error;
            })
          );
        })
      );
    },
    { dispatch: false }
  );
}
